import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import { LoginPage, RegisterPage } from './pages/AuthPages';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import PropertyDetail from './pages/PropertyDetail';
import './App.css';

// App Router with session_id detection
function AppRouter() {
  const location = useLocation();

  // Check URL fragment (not query params) for session_id
  // This must happen synchronously during render, not in useEffect
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/property/:id" element={<PropertyDetail />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LanguageProvider>
            <AppRouter />
            <Toaster 
              position="top-right" 
              toastOptions={{
                style: {
                  background: '#0A0A0A',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  color: '#F5F5F0',
                },
              }}
            />
          </LanguageProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
